import {
  isCnpjValido,
  isCpfValido,
  somenteDigitos,
} from '../../../../../../services/util/documento.service'

// Regras de forma da SEFAZ 

export function parteVazia(origem = 'manual') {
  return {
    origem,
    company_id: null,
    client_id: null,
    tipo_pessoa: 'PJ',
    cnpj_cpf: '',
    situacao_icms: 'contribuinte',
    inscricao_estadual: '',
    nome: '',
    telefone: '',
    logradouro: '',
    numero: '',
    bairro: '',
    uf: null, // { id, uf, name }
    city: null, // { id, name }
    cep: '',
  }
}

export function validarParte(parte, titulo) {
  if (!parte) return `Informe os dados do ${titulo}`
  if (parte.origem === 'empresa' && !parte.company_id) return `${titulo}: selecione a Empresa`
  if (parte.origem === 'cliente' && !parte.client_id) return `${titulo}: selecione o Cliente`
  if (parte.tipo_pessoa === 'PF' && !isCpfValido(parte.cnpj_cpf)) return `${titulo}: CPF inválido`
  if (parte.tipo_pessoa === 'PJ' && !isCnpjValido(parte.cnpj_cpf)) return `${titulo}: CNPJ inválido`

  const nome = String(parte.nome || '').trim()
  if (nome.length < 2 || nome.length > 60)
    return `${titulo}: o nome deve ter entre 2 e 60 caracteres`
  if (!parte.situacao_icms) return `${titulo}: informe a situação no ICMS`
  if (parte.situacao_icms === 'contribuinte') {
    const ie = somenteDigitos(parte.inscricao_estadual)
    if (ie.length < 2 || ie.length > 14)
      return `${titulo}: informe a Inscrição Estadual (2 a 14 dígitos)`
  }
  const telefone = somenteDigitos(parte.telefone)
  if (telefone && (telefone.length < 6 || telefone.length > 14)) {
    return `${titulo}: telefone deve ter entre 6 e 14 dígitos`
  }
  const logradouro = String(parte.logradouro || '').trim()
  if (logradouro.length < 2) return `${titulo}: informe o logradouro`
  if (!String(parte.numero || '').trim()) return `${titulo}: informe o número do endereço`
  if (String(parte.bairro || '').trim().length < 2) return `${titulo}: informe o bairro`
  if (!parte.uf) return `${titulo}: selecione a UF`
  if (!parte.city || !parte.city.id) return `${titulo}: selecione a cidade`
  if (somenteDigitos(parte.cep).length !== 8) return `${titulo}: CEP deve ter 8 dígitos`

  return null
}

// Data do calendário (Date) -> 'yyyy-MM-dd'; devolve null quando vazia ou inválida
export function dataParaIso(valor) {
  if (!valor) return null
  const data = valor instanceof Date ? valor : new Date(valor)
  if (Number.isNaN(data.getTime())) return null
  const mes = `${data.getMonth() + 1}`.padStart(2, '0')
  const dia = `${data.getDate()}`.padStart(2, '0')
  return `${data.getFullYear()}-${mes}-${dia}`
}
